// Third-party Library
import { useState } from "react"

// Component
import ModalContentWrapper from "./ModalContentWrapper"

const ModalStandard = ({
    // mode = 'link', // default setting
    children = '',
    onClick = () => {},

    // needed for modal content
    content,
    subcontent,
    title,
    icon,
    disabled = false
}) => {
    const [ open, setOpen ] = useState(false)

    // handler if 'ok' button in modal clicked
    const onClickModalHDLR = () => {
        onClick()
        setOpen(false)
    }

    return (
        <>
            <ModalContentWrapper 
                open={open} 
                onOk={onClickModalHDLR} 
                onCancel={() => setOpen(false)}
                content={content}
                subcontent={subcontent}
                title={title}
                icon={icon}
            />
            <span                 
                className={disabled ? "disabled" : "ButtonLink"}
                aria-hidden="true"
                onClick={ disabled ? () => {} : () => setOpen(true)} 
            >
                {children}
            </span>
        </>
    )
}

export default ModalStandard